import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import api from "api/axios";

function Inscription() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [valide, setValide] = useState(false);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [form, setForm] = useState({
    nom: "",
    email: "",
    ville: "",
    mot_de_passe: "",
    confirmation: "",
  });

  useEffect(() => {
    const verifier = async () => {
      try {
        await api.get(`/inscription/${token}`);
        setValide(true);
      } catch (err) {
        setError(err.response?.data?.message || "Lien invalide ou expiré.");
      } finally {
        setLoading(false);
      }
    };
    verifier();
  }, [token]);

  const handleSubmit = async () => {
    setError("");
    if (!form.nom || !form.email || !form.ville || !form.mot_de_passe) {
      setError("Tous les champs sont obligatoires.");
      return;
    }
    if (form.mot_de_passe.length < 6) {
      setError("Le mot de passe doit contenir au moins 6 caractères.");
      return;
    }
    if (form.mot_de_passe !== form.confirmation) {
      setError("Les mots de passe ne correspondent pas.");
      return;
    }
    setSubmitting(true);
    try {
      await api.post(`/inscription/${token}`, {
        nom: form.nom,
        email: form.email,
        ville: form.ville,
        mot_de_passe: form.mot_de_passe,
      });
      setSuccess(true);
      setTimeout(() => navigate("/authentication/sign-in"), 3000);
    } catch (err) {
      setError(err.response?.data?.message || "Erreur serveur.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <MDBox
      minHeight="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={{ bgcolor: "#f0f2f5" }}
    >
      <Card sx={{ width: 450, p: 3 }}>
        <MDBox textAlign="center" mb={3}>
          <MDTypography variant="h4" fontWeight="bold" sx={{ color: "#1976d2" }}>
            GestFete
          </MDTypography>
          <MDTypography variant="body2" color="text">
            Créer votre compte directeur
          </MDTypography>
        </MDBox>

        {loading && (
          <MDBox display="flex" justifyContent="center" py={3}>
            <CircularProgress />
          </MDBox>
        )}

        {!loading && error && !valide && (
          <MDBox textAlign="center" py={3} sx={{ bgcolor: "#ffebee", borderRadius: 2, p: 2 }}>
            <MDTypography variant="body2" color="error">{error}</MDTypography>
          </MDBox>
        )}

        {!loading && success && (
          <MDBox textAlign="center" py={3}>
            <MDTypography variant="h6" sx={{ color: "#43a047" }}>
              Compte créé avec succès !
            </MDTypography>
            <MDTypography variant="body2" color="text" mt={1}>
              Vous allez être redirigé vers la page de connexion...
            </MDTypography>
          </MDBox>
        )}

        {!loading && valide && !success && (
          <MDBox display="flex" flexDirection="column" gap={2}>
            <TextField
              label="Nom complet"
              fullWidth
              value={form.nom}
              onChange={(e) => setForm({ ...form, nom: e.target.value })}
            />
            <TextField
              label="Email"
              type="email"
              fullWidth
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
            />
            <TextField
              label="Ville"
              fullWidth
              value={form.ville}
              onChange={(e) => setForm({ ...form, ville: e.target.value })}
            />
            <TextField
              label="Mot de passe"
              type="password"
              fullWidth
              value={form.mot_de_passe}
              onChange={(e) => setForm({ ...form, mot_de_passe: e.target.value })}
            />
            <TextField
              label="Confirmer le mot de passe"
              type="password"
              fullWidth
              value={form.confirmation}
              onChange={(e) => setForm({ ...form, confirmation: e.target.value })}
            />

            {error && (
              <MDTypography variant="caption" color="error">{error}</MDTypography>
            )}

            <MDButton
              variant="gradient"
              color="info"
              fullWidth
              onClick={handleSubmit}
              disabled={submitting}
            >
              {submitting ? "Création..." : "Créer mon compte"}
            </MDButton>

            <MDTypography
              variant="caption"
              color="text"
              textAlign="center"
              sx={{ cursor: "pointer", color: "#1976d2" }}
              onClick={() => navigate("/authentication/sign-in")}
            >
              Déjà un compte ? Se connecter
            </MDTypography>
          </MDBox>
        )}
      </Card>
    </MDBox>
  );
}

export default Inscription;
